import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['directionRequiredMessage'];

  connect() {
    this.scopeElement = this.element.closest('[data-rule-scope]');
  }

  directionPicked() {
    if (!this.scopeElement) return false;
    const hidden = this.scopeElement.querySelector('input[type="hidden"][name$="[direction]"]');
    const picked = Boolean(hidden && hidden.value);
    this.toggleDirectionRequired(picked);
    return picked;
  }

  toggleDirectionRequired(picked) {
    if (!this.hasDirectionRequiredMessageTarget) return;
    this.directionRequiredMessageTarget.classList.toggle('hidden', picked);
  }

  setCheckboxChecked(checkbox, checked) {
    if (!checkbox) return;
    checkbox.checked = checked;
    checkbox.dispatchEvent(new Event('change', { bubbles: true }));
  }

  filterRows(rows, query) {
    const normalised = query.trim().toLowerCase();
    rows.forEach((row) => {
      const label = (row.dataset.label || '').toLowerCase();
      row.classList.toggle('hidden', normalised.length > 0 && !label.includes(normalised));
    });
  }
}
